import { ComponentProps } from 'react';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';

import { OpSkeleton } from 'new-components/DLS/OpSkeleton/OpSkeleton';
import { SosUpload } from 'new-components/DLS/SosUpload/SosUpload';

import { useOpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

interface OpFormUploadProps
  extends Pick<
      ComponentProps<typeof OpForm.Item>,
      | 'name'
      | 'label'
      | 'rules'
      | 'tooltip'
      | 'validateTrigger'
      | 'initialValue'
      | 'validateStatus' // Temp: For SUIR wrapped version
      | 'help' // Temp: For SUIR wrapped version
      | 'required' // Temp: For SUIR wrapped version
    >,
    Omit<
      ComponentProps<typeof SosUpload>,
      'name' | 'required' | 'onChange' | 'value'
    > {
  formItemClassName?: string;
  isLoading?: boolean;
  accept?: string;
  maxFileSize?: number; // in bytes, defaults to 1MB
}

export const OpFormSosUpload = ({
  // Form Item props
  formItemClassName,
  name,
  label,
  rules,
  tooltip,
  validateTrigger,
  initialValue,
  required, // TEMP: For old form component validation
  validateStatus, // TEMP: For old form component validation
  help, // TEMP: For old form component validation

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  disabled,
  testId,
  // accept = '.pdf',
  // maxFileSize,

  ...elementProps
}: OpFormUploadProps) => {
  /** The Form is wrapped in a provider that passes the loading and readOnly
   * contexts to the component */
  const { isDataLoading, isReadOnly } = useOpFormContext();

  const uuid = uuidv4();
  const opUploadId = `op-upload-${uuid}`;

  return (
    <OpForm.Item
      className={clsx('op-form-upload', formItemClassName)}
      name={name}
      label={label}
      rules={rules}
      tooltip={tooltip}
      validateTrigger={validateTrigger}
      initialValue={initialValue}
      required={required} // TEMP: For old form component validation
      validateStatus={validateStatus} // TEMP: For old form component validation
      help={help} // TEMP: For old form component validation
      testId={testId ? `${testId}-op-form-item` : undefined}
      {...(!name && { htmlFor: opUploadId })} // If a name isn't passed there is no association between the label and the input. This creates that association.
    >
      {isDataLoading || isLoading ? (
        /** A placeholder in the shape of the component
         * so we can immediately render the structure of the form while
         * data is loading */
        <OpSkeleton.Input active block />
      ) : (
        /** The actual component that is rendered when we have the data */
        <SosUpload
          disabled={isReadOnly || disabled}
          {...(!name && { id: opUploadId })} // If a name isn't passed there is no association between the label and the input. This creates that association.
          testId={testId}
          {...elementProps}
        />
      )}
    </OpForm.Item>
  );
};
